import {
  Box,
  // Text,
  // Button as CButton,
  // VStack,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

import { useEffect, useMemo, useState } from "react";
// import { ChevronRightIcon } from "@chakra-ui/icons";

// import { useParams } from "react-router-dom";
// import { CgDatabase } from "react-icons/cg";

//Components
// import Header from "components/dashHeader";
// import Sidemenu from "components/sidemenu";
import Tab from "components/Tab/Tab";

// import { ReactComponent as SampleChart } from "assets/svg/sample-wallet-chart.svg";

import CryptoDetailsBCPL from "./Panels/CryptoDetailsBCPL";
import CryptoDetailsEarn from "./Panels/CryptoDetailsEarn";
import CryptoDetailsOverview from "./Panels/CryptoDetailsOverview";
import CryptoDetailsAffiliates from "./Panels/CryptoDetailsAffiliates";

// import toUpper from "lodash/toUpper";
// import toLower from "lodash/toLower";
// import { format, parseISO } from "date-fns";
// import toPrecision from "util/toPrecision";

// import { useGetWalletTransationsQuery } from "services/walletApi";
// import { useGetCoinToUsdRateQuery } from "services/rateApi";
// import useWallet from "hooks/useWalletBalance";
import constants from "config/constant";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const CryptoDetails = ({ coin }) => {
  const location = useLocation();
  const params = useMemo(
    () => new URLSearchParams(location?.search),
    [location]
  );

  const [tabIndex, setTabIndex] = useState(0);

  const isLoanable = useMemo(
    () => constants.supportedLoanableCoins.includes(coin),
    [coin]
  );

  const isStakable = useMemo(
    () => constants.supportedStakableCoins.includes(coin),
    [coin]
  );

  const handleTabIndex = (index) => {
    setTabIndex(index);
  };

  const mappedTabIndex = useMemo(() => {
    const map = {
      overview: 0,
      earn: 1,
      bcpl: 2,
      partner: 3,
    };

    return map[params.get("tab") ?? "overview"];
  }, [params]);

  useEffect(() => {
    if (params.has("tab")) {
      setTabIndex(mappedTabIndex);
    }
  }, [mappedTabIndex, params]);

  return (
    <Box mt="32px">
      <Tabs
        variant="ghost"
        colorScheme="green"
        onChange={handleTabIndex}
        index={tabIndex}
        // d={["none", "none", "block"]}
      >
        <TabList
          bg="white"
          px="20px"
          borderRadius={[0, "8px"]}
          overflowX="overlay"
          sx={{
            "::-webkit-scrollbar": {
              h: "2px",
            },
          }}
        >
          <Tab>Overview</Tab>
          {isStakable && <Tab>Earn</Tab>}
          {isLoanable && <Tab>BCPL</Tab>}
          <Tab>Partners</Tab>
        </TabList>

        <TabPanels>
          <TabPanel px="0">
            <CryptoDetailsOverview coin={coin} />
          </TabPanel>
          {isStakable && (
            <TabPanel px="0">
              <CryptoDetailsEarn coin={coin} />
            </TabPanel>
          )}
          {isLoanable && (
            <TabPanel px="0">
              <CryptoDetailsBCPL coin={coin} />
            </TabPanel>
          )}
          <TabPanel px="0">
            <CryptoDetailsAffiliates coin={coin} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default CryptoDetails;
